<template>
  <div>
    <v-row align="center" dense>
      <v-col cols="12">
        <v-card :loading="isLoading" elevation="1" class="rounded-xl">
          <v-card-title>
            Indicar el parametro de busqueda
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid" lazy-validation ref="infoForm">
              <v-row align="center" dense>

                <!-- numero de guia -->
                <v-col cols="12" sm="6" md="4">
                  <BaseAutoComp
                    textoBusqueda="Digite numero de guia"
                    label="Buscar Guia..."
                    :itemText="['id', 'numero', 'destino']"
                    itemValue="id"
                    :advanceSearchFields="{
                      'a.numero': null,
                      'b.destino': null,
                    }"
                    rutaItemAuto="transjuma/GuiaSelect"
                    :procesoCompleto="procesoCompleto"
                    v-on:change-auto="selected"
                    fieldName="Numero de Guia"
                    :modoEdicion="false"
                  >

                  </BaseAutoComp>
                </v-col>

                <!-- fecha -->
                <v-col cols="12" sm="4" md="3" class="mt-3">
                  <v-menu
                    v-model="fecha"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="infoForm.fecha"
                        label="Fecha"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="infoForm.fecha"
                      @input="fecha = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="3" >
                  <v-btn
                    class="rounded-xl" 
                    color="primary"
                    @click="buscarGuia"
                    >
                    Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="dataRows"
      class="elevation-1 rounded-xl px-2 mt-3"
      @click:row="openInformation"
      :items-per-page="15"
      :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-left-circle-outline',
          lastIcon: 'mdi-arrow-right-circle-outline',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          showCurrentPage: true
        }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Busqueda personalizada por Guia</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
    </v-data-table>
    
    <div class="text-center">
      <v-dialog
        v-model="dialog"
        width="700"
      >
        

        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Detalles de ajustes y deducciones
          </v-card-title>

          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Fecha
                    </th>
                    <th class="text-left">
                      Origen
                    </th>
                    <th class="text-left">
                      Transportista
                    </th>
                    <th class="text-left">
                      Detalle
                    </th>
                    <th class="text-left">
                      Monto
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="ajuste in dataDetail.ajustes"
                    :key="ajuste.id"
                  >
                    <td>{{ ajuste.fecha }}</td>
                    <td>{{ `Ajuste` }}</td>
                    <td>{{ ajuste.transportista }}</td>
                    <td>{{ ajuste.tipo_ajuste }}</td>
                    <td>{{ ajuste.valor_adicional ? $convertToMoney(ajuste.valor_adicional): 0 }}</td>
                  </tr>
                   <tr
                    v-for="dedu in dataDetail.deducciones"
                    :key="dedu.id"
                  >
                    <td>{{ dedu.fecha.substr(0,10) }}</td>
                    <td>{{ `Deduccion` }}</td>
                    <td>{{ dedu.transportista_deduccion }}</td>
                    <td>{{ dedu.tipo_deduccion }}</td>
                    <td>{{ dedu.monto ? $convertToMoney(dedu.monto*-1) : 0 }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
   
  </div>
</template>

<script>
import { axiosC } from "../api/axiosbd"
import BaseAutoComp from "../components/BaseAutoComplet.vue";
export default {
  components:{
    BaseAutoComp
  },
  data() {
    return {
      valid: false,
      search: "",
      dialog: false,
      isLoading: false,
      infoForm: {
        fecha: null,
        numero: null
      },
      fecha: false,
      headers: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Estado', value: 'estado' },
        { text: 'Guia', value: 'guia' },
        { text: 'Destino ID', value: 'destinoId' },
        { text: 'Tonelada', value: 'tonelada' },
        { text: 'Destino', value: 'destino' },
        { text: 'Transportista', value: 'transportista' },
        { text: 'Total Guia', value: 'total_guia', align: 'right' },
        { text: 'Total Ajustes', value: 'total_ajustes', align: 'right' },
        { text: 'Total Deducciones', value: 'total_deduciones', align: 'right' },
        // { text: 'Fecha proforma', value: 'fecha_proforma' },
      ],
      dataRows: [],
      dataResponse : [],
      dataDetail: [],
      totalAjustes: [],
      totalDeducciones: [],
      urlParams: '?updatedAt[order]=desc',
      procesoCompleto: false
    }
  },
  methods: {
    selected(item){
      console.log(item)
      this.infoForm.numero = item.itemSelected ? item.itemSelected.numero : null
    },
    async getData() {
      this.showTable = false
    },
    buscarGuia(){
      this.isLoading = true
      console.log(this.infoForm)
      this.buildDesserts()
    },
    openInformation(row) {
      this.dialog = true
      this.dataDetail = this.dataResponse.filter((item)=> item.guia.id == row.id)[0] 
      
    },

    async buildDesserts() {
      this.isLoading = true
      const query = new URLSearchParams()
      for (const key in this.infoForm) {
        if (this.infoForm.hasOwnProperty(key)) {
          query.append(key, this.infoForm[key]);
        }
      }

      try {
        let dataReporte = await axiosC({
          method: "GET",
          url: `/transjuma/infoGuia`,
          headers: {
            Authorization: `Bearer ${this.$store.state.AuthModule.accessToken}`,
          },
          params: query
        })
        if (dataReporte.status >= 400) throw new Error('Opps error en la peticion')
        
        console.log(dataReporte)

        this.dataResponse = dataReporte.data
        this.dataRows = []
        this.totalAjustes = []
        this.totalDeducciones = []
        
        for (let item of dataReporte.data) {
          let sumAjuste = 0
          if (item.ajustes) {
            for (let ajuste of item.ajustes){
              this.totalAjustes.push(ajuste.valor_adicional)
            }
            sumAjuste = this.totalAjustes.reduce((a, b) => a + b, 0)
          }

          let sumDeduccion = 0
          if (item.deducciones) {
            for (let deduccion of item.deducciones){
              this.totalDeducciones.push(deduccion.monto*-1)
            }
            sumDeduccion = this.totalDeducciones.reduce((a, b) => a + b, 0)
          }
          
          this.dataRows.push({
            id: item.guia.id,
            fecha: item.guia.fecha ? item.guia.fecha.substr(0, 10) : null,
            guia: item.guia.numero,
            destinoId: item.guia.destino_tonelada,
            tonelada: item.guia.destino_tonelada,
            destino: item.guia.destino,
            estado: item.guia.estado_guia,
            transportista: item.guia.transportista,
            total_guia: this.$convertToMoney(item.guia.precio),
            total_ajustes: this.$convertToMoney(sumAjuste),
            total_deduciones: this.$convertToMoney(sumDeduccion),
          })
          this.totalAjustes = []
          this.totalDeducciones = []
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log(error.response)
        alert(error.response.data)
      }
    },
  },
  computed: {
  },
  created() {
   
  }
}
</script>